  <template>
  <div class="restbooktimeset" :style="{ gridTemplateColumns: '1fr 1.45fr' }">
    <div>
      <editBox :label="'自取設定'" @edit="edit=$event ? 1 : null" :edit="edit===1" @save="save">
        <template slot="edit" v-if="edit===1&&editItem">
          <div class="containerB-box"><span>自取功能</span>
            <RT :options="['開放自取', '關閉']" :width="'125px'" :defaultValue="editItem.restTakeout ? '開放自取' : '關閉'" @input="editItem.restTakeout=$event === '開放自取'"/>
          </div>
          <div class="inputtimeselect">
            <label for="infinity"><input type="radio" id="infinity" v-model="editItem.Infinity" :value="true">無期限</label>
          </div>
          <div class="inputtimeselect">
            <label for="limit"><input type="radio" id="limit" v-model="editItem.Infinity" :value="false">開放自取功能日期</label>
            <RangeInput :style="{marginLeft: '25px', width: '350px'}" :defaultValue="editItem.range" @input="editItem.Infinity=false;editItem.range=$event "/>
          </div>
        </template>
        <template>
          <div class="containerB-box"><span>自取功能</span> <RT :options="['開放自取', '關閉']" :width="'125px'" :disabled="true" :defaultValue="info.restTakeout ? '開放自取' : '關閉'"/></div>
          <template v-if="info.restTakeout">
            <div class="inputtimeselect" v-if="info.restTakeoutFnRange?.Infinity">無期限開放自取功能</div>
            <div class="inputtimeselect" v-else>開放自取功能日期
              <div class="rangeView">{{ toDate(info.restTakeoutFnRange?.start) }} - {{ toDate(info.restTakeoutFnRange?.end) }}</div>
            </div>
          </template>
        </template>
      </editBox>
      <editBox :label="'取貨日範圍設定'" @edit="edit=$event ? 2 : null" :edit="edit===2" @save="save">
        <div class="takeRangeWeekend" v-if="info.restTakeoutAvaRange?.mode">
          <div class="dot"><template v-if="!info.restTakeoutWeekday">不</template>開放平日取貨</div>
          <div class="dot"><template v-if="!info.restTakeoutHoliday">不</template>開放假日取貨</div>
        </div>
        <div class="takeRange" v-if="info.restTakeoutAvaRange?.mode===1">開放<template v-if="info.restTakeoutAvaRange?.start?.unit==='hours'||info.restTakeoutAvaRange?.start?.unit==='minutes'">當天</template> <span class="num">{{info.restTakeoutAvaRange?.start?.value}}</span> <span>{{units[info.restTakeoutAvaRange?.start?.unit]}}</span>後到 <span class="num">{{info.restTakeoutAvaRange?.end?.value}}</span> <span>{{units[info.restTakeoutAvaRange?.end?.unit]}}</span>前可取貨。</div>
        <div class="takeRange" v-else-if="info.restTakeoutAvaRange?.mode===2">開放 <div class="rangeView"  :style="{marginInline: '.5em'}">{{ toDate(info.restTakeoutAvaRange?.range?.start) }} - {{ toDate(info.restTakeoutAvaRange?.range?.end) }}</div> 可取貨。</div>
        <template slot="edit" v-if="edit===2">
          <div class="takeRangeWeekend" v-if="info.restTakeoutAvaRange?.mode">
          <div class="switch" label="平日取貨"><input type="checkbox" :checked="info.restTakeoutWeekday"  @change="$emit('update', { 'restTakeoutWeekday': $event.target.checked })"></div>
          <div class="switch" label="假日取貨"><input type="checkbox" :checked="info.restTakeoutHoliday"  @change="$emit('update', { 'restTakeoutHoliday': $event.target.checked })"></div>
          </div>
          <div class="inputtimeselect">
            <label for="infinity"><input type="radio" id="infinity" v-model="editItem.mode" :value="1"></label>
            <div class="takeRangeEdit" :style="{marginLeft: '20px'}">
              <div :style="{display:'grid', gridTemplateColumns: '1fr', height: '120px'}">
                <div>
                  開放當天
                  <input type="text" v-model.number="editItem.start.value">
                  <select v-model="editItem.start.unit">
                  <option value="minutes">分鐘</option>
                  <option value="hours">小時</option>
                  <option value="days">天</option>
                  <option value="weeks">週</option>
                  <option value="months">月</option>
                </select>
                後
                </div>
                <div>
                  到
                <input type="text" v-model.number="editItem.end.value">
                <select v-model="editItem.end.unit">
                  <option value="minutes">分鐘</option>
                  <option value="hours">小時</option>
                  <option value="days">天</option>
                  <option value="weeks">週</option>
                  <option value="months">月</option>
                </select>
                前可取貨。
                </div>
              </div>
            </div>
          </div>
          <div class="inputtimeselect">
            <label for="infinity"><input type="radio" id="infinity" v-model="editItem.mode" :value="2"></label>
            <div class="inputRangeflex">
              開放 <RangeInput :style="{width: '350px'}" :defaultValue="editItem.range" @input="editItem.mode=2;editItem.range=$event "/>
              取貨。
            </div>
          </div>
        </template>
      </editBox>
      <editBox :label="'自取付款方式'" :color="'#CC9B6D'" @edit="edit=$event ? 5 : null" :edit="edit===5" @save="save" v-if="info">
        <template>
          <div v-if="info.onlinePayment.enabled" class="showMethod">
            <span>付款方式 <span :style="{fontSize:'16px', color: '#999999'}">滑鼠托拽方塊可進行排序</span></span>
            <draggable :value="sortedMethods" @input="sortedMethods=$event">
              <div v-for="(method, m) in sortedMethods" :key="`showMethod-${m}`">{{method}}</div>
            </draggable>
            <BtnsS v-if="sortedMethods.join('_')!==info.onlinePayment.methods.join('_')"
            @cancel="sortedMethods=info.onlinePayment?.methods || []" :save="'儲存排序'"
            @save="$emit('update', { 'onlinePayment.methods': sortedMethods })"/>
          </div>
          <div v-else class="showMethod">無付款方式，僅人工收單處理</div>
        </template>
        <template slot="edit" v-if="edit===5">
          <div class="inputtimeselect">
            <label for="enabledtrue"><input type="radio" id="enabledtrue" v-model="editItem.enabled" :value="false">無付款方式，僅人工收單處理</label>
          </div>
          <div class="inputtimeselect">
            <label for="enabledfalse"><input type="radio" id="enabledfalse" v-model="editItem.enabled" :value="true">需選擇付款方式</label>
          </div>
          <div class="flexWrap" v-if="editItem.enabled">
            <div class="switchspay">
              <div class="switch" v-for="(method, m) in methods" :key="`method-${m}`" :label="method">
                <input type="checkbox" v-model="editItem.methods" :value="method">
              </div>
            </div>
          </div>
        </template>
      </editBox>
      <!-- <editBox :label="'匯款時間設定'" :color="'#CC9B6D'" @edit="edit=$event ? 6 : null" :edit="edit===6" @save="save" v-if="info">
        <div class="remittance">線上訂購應於訂購日起算 <span>{{info.remittance?.dayAfterBooking || 3}}</span> 天內或是取貨日 <span>{{info.remittance?.dayBeforeTakeout || 3}}</span> 天前匯款。</div>
        <div class="remittance" slot="edit" v-if="edit===6">
          線上訂購應於 訂購日起算<input type="text" v-model="editItem.dayAfterBooking"> 天內
          <br>或是取貨日<input type="text" v-model="editItem.dayBeforeTakeout">天前匯款。</div>
      </editBox> -->
      <editBox :label="'匯款時間設定'" :color="'#CC9B6D'" @edit="edit=$event ? 6 : null" :edit="edit===6" @save="save" v-if="info">
        <div class="remittance">線上訂購應於訂購日起算 <span>{{info.remittance?.dayAfterBooking || 3}}</span> 天內匯款。</div>
        <div class="remittance" slot="edit" v-if="edit===6">
          線上訂購應於 訂購日起算<input type="text" v-model="editItem.dayAfterBooking"> 天內匯款。</div>
      </editBox>
      <!-- <editBox :label="'取消時間設定'" :color="'#CC9B6D'" @edit="edit=$event ? 7 : null" :edit="edit===7" @save="save" v-if="info">
        <div class="remittance">線上訂購若要取消應於訂購日起算 <span>{{info.cancelBooking?.dayAfterBooking || 3}}</span> 天內或是取貨日 <span>{{info.cancelBooking?.dayBeforeTakeout || 3}}</span> 天前取消。</div>
        <div class="remittance" slot="edit" v-if="edit===7">
          線上訂購應於 訂購日起算<input type="text" v-model="editItem.dayAfterBooking"> 天內
          <br>或是取貨日<input type="text" v-model="editItem.dayBeforeTakeout">天前取消。</div>
      </editBox> -->
      <editBox :label="'取消時間設定'" :color="'#CC9B6D'" @edit="edit=$event ? 7 : null" :edit="edit===7" @save="save" v-if="info">
        <div class="remittance">線上訂購若要取消應於取貨日 <span>{{info.cancelBooking?.dayBeforeTakeout || 3}}</span> 天前取消。(限未付款)</div>
        <div class="remittance" slot="edit" v-if="edit===7">取貨日<input type="text" v-model="editItem.dayBeforeTakeout">天前取消。(限未付款)</div>
      </editBox>
      <!-- <editCubeDate :title="'自取時段設定 - 平日'" :defaultValue="info.restTimetakeout" @save="$emit('update', { restTimetakeout: $event })"/>
      <editCubeDate :title="'自取時段設定 - 假日'" :defaultValue="info.restTimetakeoutHoliday" @save="$emit('update', { restTimetakeoutHoliday: $event })"/> -->
    </div>
    <div :style="{borderTop: '1px solid #CACACA'}">
      <div class="switchs">
        <div>公休日(週)  <div v-if="Object.keys(info.WeekdayOff).filter(e => info.WeekdayOff[e]).length>0" :style="{marginLeft: '30px'}">{{Object.keys(info.WeekdayOff).filter(e => info.WeekdayOff[e]).map(e => '週'+wdy[e]).join('、')}}公休</div></div>
        <div>
          <div label="週一"><input type="checkbox" class="invert" :checked="info.WeekdayOff[1]"  @change="$emit('update', { 'WeekdayOff.1': $event.target.checked })"></div>
          <div label="週二"><input type="checkbox" class="invert" :checked="info.WeekdayOff[2]"  @change="$emit('update', { 'WeekdayOff.2': $event.target.checked })"></div>
          <div label="週三"><input type="checkbox" class="invert" :checked="info.WeekdayOff[3]"  @change="$emit('update', { 'WeekdayOff.3': $event.target.checked })"></div>
          <div label="週四"><input type="checkbox" class="invert" :checked="info.WeekdayOff[4]"  @change="$emit('update', { 'WeekdayOff.4': $event.target.checked })"></div>
          <div label="週五"><input type="checkbox" class="invert" :checked="info.WeekdayOff[5]"  @change="$emit('update', { 'WeekdayOff.5': $event.target.checked })"></div>
          <div label="週六"><input type="checkbox" class="invert" :checked="info.WeekdayOff[6]"  @change="$emit('update', { 'WeekdayOff.6': $event.target.checked })"></div>
          <div label="週日"><input type="checkbox" class="invert" :checked="info.WeekdayOff[0]"  @change="$emit('update', { 'WeekdayOff.0': $event.target.checked })"></div>
        </div>
      </div>
      <div>
        <div class="title" :style="{marginBottom: '40px'}">自取時段設定</div>
        <div class="wdyTime" v-if="timeType==='外帶時段'">
          <editCubeDate v-for="i in 7" :key="`wdy-${i}`" :style="{width: '125px'}"
          :title="'週' + wdy[i % 7]" :col="true" :defaultValue="info.takeoutTime[i % 7]"
          @save="updateTime('takeoutTime', i % 7, $event)" />
        </div>
        <div class="wdyTime" v-else>
          <editCubeDate v-for="i in 7" :key="`wdy-${i}`" :style="{width: '125px'}"
          :title="'週' + wdy[i % 7]" :col="true" :defaultValue="info.restTime[i % 7]"
          @save="updateTime('restTime', i % 7, $event)" />
        </div>
      </div>
      <editCubeDate title="專案" :defaultValue="info.restProject" @save="$emit('update', { restProject: $event })"/>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import RangeInput from '../../components/input/dateRange.vue'
import RT from '../../components/radio/r1.vue'
import editBox from './editBox.vue'
import editCubeDate from '../../components/editCube3info.vue'
export default {
  name: 'restBookSummarySet',
  props: ['info', 'timeType'],
  components: {
    editCubeDate,
    editBox,
    RT,
    RangeInput,
    draggable
  },
  data () {
    return {
      edit: null,
      restRatioHoliday: 0,
      restRatioWeekday: 0,
      editItem: null,
      methods: ['匯款', '信用卡', 'LINE PAY', '到店付款'],
      wdy: ['日', '一', '二', '三', '四', '五', '六'],
      sortedMethods: [],
      units: {
        minutes: '分鐘',
        hours: '小時',
        days: '天',
        weeks: '週',
        months: '月'
      }
    }
  },
  computed: {
  },
  async mounted () {
  },
  watch: {
    edit () {
      switch (this.edit) {
        case 1:
          this.editItem = {
            restTakeout: this.info.restTakeout,
            Infinity: this.info.restTakeoutFnRange?.Infinity,
            range: {
              start: this.moment(this.info.restTakeoutFnRange?.start || null).format('yyyy-MM-DD'),
              end: this.moment(this.info.restTakeoutFnRange?.end || null).format('yyyy-MM-DD')
            }
          }
          break
        case 2:
          this.editItem = this.info.restTakeoutAvaRange ? {
            ...({ mode: this.info.restTakeoutAvaRange.mode || 1 }),
            ...({ start: this.info.restTakeoutAvaRange.start || { value: 60, unit: 'minutes' } }),
            ...({ end: this.info.restTakeoutAvaRange.end || { value: 180, unit: 'days' } }),
            ...(this.info.restTakeoutAvaRange.range ? {
              range: {
                start: this.moment(this.info.restTakeoutAvaRange.range.start).format('YYYY-MM-DD'),
                end: this.moment(this.info.restTakeoutAvaRange.range.end).format('YYYY-MM-DD')
              }
            } : { range: { start: null, end: null } })
          } : {
            mode: 1,
            start: { value: 5, unit: 'days' },
            end: { value: 180, unit: 'days' },
            range: {
              start: null,
              end: null
            }
          }
          break
          // this.editItem = this.info.restTakeoutAvaRange || {
          //   mode: 1,
          //   start: { value: 60, unit: 'minutes' },
          //   end: { value: 180, unit: 'days' },
          //   range: {
          //     start: null,
          //     end: null
          //   }
          // }
          // break
        case 3:
          this.editItem = {
            restDeliver: this.info.restDeliver,
            Infinity: this.info.restDeliverFnRange?.Infinity || true,
            range: {
              start: this.moment(this.info.restDeliverFnRange?.start || null).format('yyyy-MM-DD'),
              end: this.moment(this.info.restDeliverFnRange?.end || null).format('yyyy-MM-DD')
            }
          }
          break
        case 4:
          this.editItem = this.info.restDeliverAvaRange || {
            mode: 1,
            start: { value: 5, unit: 'days' },
            end: { value: 180, unit: 'days' },
            range: {
              start: null,
              end: null
            }
          }
          break
        case 5:
          this.editItem = this.info.onlinePayment || {
            enabled: false,
            methods: []
          }
          break
        case 6:
          this.editItem = {
            dayAfterBooking: isNaN(parseInt(this.info.remittance?.dayAfterBooking)) ? 3 : parseInt(this.info.remittance?.dayAfterBooking)
            // dayBeforeTakeout: isNaN(parseInt(this.info.remittance?.dayBeforeTakeout)) ? 3 : parseInt(this.info.remittance?.dayBeforeTakeout)
          }
          break
        case 7:
          this.editItem = {
            // dayAfterBooking: isNaN(parseInt(this.info.cancelBooking?.dayAfterBooking)) ? 0 : parseInt(this.info.cancelBooking?.dayAfterBooking),
            dayBeforeTakeout: isNaN(parseInt(this.info.cancelBooking?.dayBeforeTakeout)) ? 3 : parseInt(this.info.cancelBooking?.dayBeforeTakeout)
          }
          break
      }
    },
    info: {
      deep: true,
      immediate: true,
      handler () {
        this.sortedMethods = this.info.onlinePayment?.methods || []
      }
    }
  },
  methods: {
    save () {
      switch (this.edit) {
        case 1:
          this.$emit('update', {
            restTakeout: this.editItem.restTakeout,
            restTakeoutFnRange: {
              Infinity: this.editItem.Infinity,
              start: this.editItem.range.start ? this.moment(this.editItem.range.start).startOf('day').toISOString() : null,
              end: this.editItem.range.end ? this.moment(this.editItem.range.end).endOf('day').toISOString() : null
            }
          })
          break
        case 3:
          this.$emit('update', {
            restDeliver: this.editItem.restDeliver,
            restDeliverFnRange: {
              Infinity: this.editItem.Infinity,
              start: this.editItem.range.start ? this.moment(this.editItem.range.start).startOf('day').toISOString() : null,
              end: this.editItem.range.end ? this.moment(this.editItem.range.end).endOf('day').toISOString() : null
            }
          })
          break
        case 2:
          this.$emit('update',
            {
              restTakeoutAvaRange: {
                mode: this.editItem.mode,
                ...(this.editItem.mode === 2 ? {
                  range: {
                    start: this.moment(this.editItem.range.start).startOf('day').toISOString(),
                    end: this.moment(this.editItem.range.end).endOf('day').toISOString()
                  }
                } : {
                  start: this.editItem.start, end: this.editItem.end
                })
              }
            }
          )
          break
        case 4:
          this.$emit('update', { restDeliverAvaRange: this.editItem })
          break
        case 5:
          this.$emit('update', { onlinePayment: this.editItem })
          break
        case 6:
          this.$emit('update', { remittance: this.editItem })
          break
        case 7:
          this.$emit('update', { cancelBooking: this.editItem })
          break
      }
      this.edit = null
    },
    updateTime (key, index, event) {
      this.$emit('update', { [`${key}.${index}`]: event })
    }
  }

}
</script>
<style lang="scss">
.inputRangeflex {
  display: flex;
  align-items: center;
  margin-left: 25px;
  gap: 10px;
}
.takeRangeEdit {
  text-align: start;
  font-size: 20px;
  letter-spacing: .1em;
  font-family: Roboto;
  color: #6D6D6D;
  display: flex;
  align-items: center;
  select {
    width: fit-content;
    color: #FF8B8B;
    font-weight: 700;
  }
  input[type=text] {
    width: 100px;
    text-align: center;
    width: 100px;
    height: 37px;
    border: 1px solid #CACACA;
    align-items: center;
    justify-content: center;
    letter-spacing: .05em;
    font-weight: 700;
    color: #FF8B8B;
    margin-inline: .5em;
  }

}
.takeRangeWeekend {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;
  &>div.dot {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    font-size: 20px;
    &::before {
      border-radius: 10px;
      width: 10px;
      height: 10px;
      background-color: var(--color-pri);
      border:3px solid  #FFFFFF;
      outline: 1px solid var(--color-pri);
      display: inline-flex;
      content: '';
    }
  }
  .switch {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    font-size: 20px;
    &::before {
      width: 4em;
      content: attr(label);
    }
  }
  input[type=checkbox] {
    appearance: none;
    width: 39px;
    height: 20px;
    border-radius: 10px;
    position: relative;
      background-color: #FF8B8B;
    &:checked {
      background-color: #85CA9E;
    }
    &::before {
      content: '';
      display: inline-flex;
      width: 16px;
      height: 16px;
      position: absolute;
      left: 2px;
      right: auto;
      top: 2px;
      background-color: #FFFFFF;
      border-radius: 8px;
    }
    &:checked::before {
      right: 2px;
      left: auto;
    }
    &.invert {
      background-color: #85CA9E;
      &:checked {
        background-color: #FF8B8B;
      }
    }
  }
}
.takeRange {
  text-align: start;
  font-size: 20px;
  letter-spacing: .1em;
  font-family: Roboto;
  color: #6D6D6D;
  display: flex;
  align-items: center;
  span {
    color: #6D6D6D;
    // font-weight: 700;
    margin: 0;
    // color: #FF8B8B;
  }
  .num {
    display: inline-flex;
    width: 100px;
    height: 37px;
    border: 1px solid #CACACA;
    align-items: center;
    justify-content: center;
    letter-spacing: .05em;
    font-weight: 700;
    color: #FF8B8B;
    margin-inline: .5em;
  }
}
.rangeView {
  margin-left: 25px;
  border: 1px solid #CACACA;
  padding-inline: 20px;
  border-radius: 3px;
  height: 40px;
  width: 350px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  letter-spacing: .05em;
  &::after {
    content: '';
    width: 20px;
    height: 20px;
    display: inline-block;
    mask-image: url(./svg/icon/celender.svg);
    background-color: var(--color-pri);
    mask-repeat: no-repeat;
    mask-position: center;
    margin-left: auto;
  }
}
.inputtimeselect {
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #5E5E5E;
  label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    input[type=radio] {
      width: 24px;
      height: 24px;
      appearance: none;
      border: 2px solid var(--color-pri);
      border-radius: 12px;
      &:checked {
        background-color: var(--color-checked);
        display: flex;
        align-items: center;
        justify-content: center;
        &::before {
          content: '';
          width: 10px;
          height: 10px;
          display: inline-block;
          background-color: #FFFFFF;
          border-radius: 10px;
        }
      }
    }
  }
  #setDateRange-input {
    text-align: flex-start;
    height: 40px;
    &::placeholder {
      text-align: center;
    }
  }
}
</style>
<style lang="scss" scoped>
.remittance {
  font-size: 20px;
  text-align: start;
  span{
    font-size: 22px;
    font-weight: 700;
    color: var(--highlight);
    margin-inline: 10px;
  }
  input[type=text] {
    width: 100px;
    border: 1px solid #CACACA;
    height: 45px;
    margin-inline: 10px;
    border-radius: 3px;
    text-align: center;
  }
}
.wdyTime {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 1000px;
  gap: 20px;
  align-items: flex-start;
}
.title {
  font-family: "Noto Sans TC";
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--color-pri);
  width: -webkit-fill-available;
}
.containerB-box {
  display: flex;
  font-size: 20px;
  gap: 16px;
  align-items: center;
  color: #5E5E5E;
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #FF8B8B;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
.editBtn {
  margin-left: auto;
  width: 35px;
  height: 35px;
  background-color: var(--color-pri);
  background-image: url(./pen.svg);
  background-position: center;
  background-repeat: no-repeat;
  border: none;
  border-radius: 50%;
  background-size: 19px;
}
.attendance {
  height: 50px;
  display: block;
  font-weight: 400;
  font-size: 25px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  font-family: 'Roboto';
  &>div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 80px;
  }
  &>div>div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    &::after {
      content: '%';
    }
  }
  input {
    width: 100px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    font-family: Roboto;
    letter-spacing: 2px;
    color: #FF8B8B;
      }
}
.switchs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
  margin-bottom: 15px;
  &>div:nth-child(2) {
    display: flex;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    width: 100%;
    height: fit-content;
    align-items: center;
    justify-content: flex-start;
    margin-block: 10px 30px;

    &>div {
      width: 100px;
      height: fit-content;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      padding: 33.5px 20px;
      border: 2px dashed var(--color-pri);
      border-radius: 5px;
      gap: 20px;
      &::before {
        content: attr(label);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
      }
      &.min {
        width: 260px;
      }
      &.min::after{
        content: attr(after);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
        align-self: x;
      }
    }
    input[type=text] {
      height: 40px;
      width: 100px;
      border: 1px solid #C4C4C4;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      font-family: Roboto;
      letter-spacing: 2px;
      color: #FF8B8B;
    }
    input[type=checkbox] {
      appearance: none;
      width: 39px;
      height: 20px;
      border-radius: 10px;
      position: relative;
        background-color: #FF8B8B;
      &:checked {
        background-color: #85B8B9;
      }
      &::before {
        content: '';
        display: inline-flex;
        width: 16px;
        height: 16px;
        position: absolute;
        left: 2px;
        right: auto;
        top: 2px;
        background-color: #FFFFFF;
        border-radius: 8px;
      }
      &:checked::before {
        right: 2px;
        left: auto;
      }
      &.invert {
        background-color: #85B8B9;
        &:checked {
          background-color: #FF8B8B;
        }
      }
    }
  }
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;

  }
}
.boxx {
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;
  }
}
.restbooktimeset {
  display: grid;
  &>div{
    &:nth-child(1) {
      padding: 25px 53px 25px 82px;
    }
    &:nth-child(2) {
      border-left: 1px solid var(--color-pri);
      &>div{
        padding: 25px 50px 25px 50px;
      }
      //
    }
    box-sizing: border-box;
    overflow-y: auto;
    height: calc(100vh - 90px);
  }
}

.desc {
  margin-top: 26px;
  color: var(--unnamed, #6D6D6D);
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 2px;
  gap: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
    input[type=text] {
      height: 40px;
      width: 100px;
      border: 1px solid #C4C4C4;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      font-family: Roboto;
      letter-spacing: 2px;
      color: #FF8B8B;
    }
    select {
      height: 40px;
      border: 1px solid #C4C4C4;
      border-radius: 3px;
      margin-right: 3px;
    }
  span {
    color: var(--unnamed, #FF8B8B);
    font-family: Noto Sans TC;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 30px */
    letter-spacing: 1px;
    margin-inline: .5em;
    &:nth-child(odd) {
      display: inline-flex;
      border: 1px solid #CACACA;
      width: 100px;
      height: 37px;
      align-items: center;
      justify-content: center;

    }
  }
}
</style>
